import logo from './logo.svg';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './style/style.css';
import './style/responsive.css';
import 'react-loading-skeleton/dist/skeleton.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Wohnen } from './pages/Wohnen';
import { WohnenBgz } from './pages/WohnenBgz';
import { Siedlungen } from './pages/Siedlungen';
import { SiedlungenDetail } from './pages/SeidlungenDetail';
import { AnmeldungWohnen } from './pages/AnmeldungWohnen';
import { WohnenFormulare } from './pages/WohnenFormulare';
import { DokumenteReglemente } from './pages/DokumenteReglemente';
import { WohnenTipps } from './pages/WohnenTipps';
import { WohnenHauswartung } from './pages/WohnenHauswartung';
import { FreieMietobjekte } from './pages/FreieMietobjekte';
import { FreieMietobjekteDetail } from './pages/FreieMietobjekteDetail';
import { FragenAntworten } from './pages/FragenAntworten';
import { Bauprojekte } from './pages/Bauprojekte';
import { NeubauProjekte } from './pages/NeubauProjekte';
import { NeubauProjekteDetail } from './pages/NeubauProjekteDetail';
import { Sanierungen } from './pages/Sanierungen';
import { SanierungenDetail } from './pages/SanierungenDetail';
import { GrundstuckVerkaufen } from './pages/GrundstuckVerkaufen';
import { Aktuelles } from './pages/Aktuelles';
import { AktuellesDetail } from './pages/AktuellesDetail';
import { Datenschutz } from './pages/Datenschutz';
import { Impressum } from './pages/Impressum';
import { Medien } from './pages/Medien';
import { VielenDank } from './pages/VielenDank';
import { Error } from './pages/Error';
import { GenossenSchaft } from './pages/GenossenSchaft';
import { Portrait } from './pages/Portrait';
import { Team } from './pages/Team';
import { Genossenschafter } from './pages/Genossenschafter';
import { SozialesEngagement } from './pages/SozialesEngagement';
import { Jobs } from './pages/Jobs';
import { Geschichte } from './pages/Geschichte';
import ScrollToTop from './components/ScrollToTop';
import { SearchResult } from './pages/SearchResult';

import { HelmetProvider } from 'react-helmet-async';
import ScrollToTopButton from './components/ScrollToTopButton';
import StrapiStructure from './modules/StrapiStructure';
import { PionierProjekte } from './pages/PionierProjekte';
import { PionierProjekteDetail } from './pages/PionierProjekteDetail';
import { AnmeldungWarteliste } from './pages/AnmeldungWarteliste';
import { Reparaturmeldung } from './pages/Reparaturmeldung';
import { SchlusselBestellen } from './pages/SchlusselBestellen';
import { InternerWohnungswechsel } from './pages/InternerWohnungswechsel';
import { Parkplatz } from './pages/Parkplatz';
import { VorherNachher } from './pages/VorherNachher';
import { Innovationen } from './pages/Innovationen';
import { WirNachhaltigkeit } from './pages/WirNachhaltigkeit';
import { OekologischBauen } from './pages/OekologischBauen';
import { NachhaltigkeitZahlen } from './pages/NachhaltigkeitZahlen';
import { VisionMissionLeitbild } from './pages/VisionMissionLeitbild';
import { useEffect } from 'react';

function App() {
  
  return (
    <BrowserRouter>
      <HelmetProvider>
        <ScrollToTop />
        <ScrollToTopButton />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path='/wohnen' element={<Wohnen />} /> */}
          {/* <Route path='/wohnen' element={<Navigate to="/wohnen-in-der-bgz" replace />} /> */}
          <Route path='/siedlungen' element={<Siedlungen />} />
 
          <Route path='/siedlungen/:title' element={<SiedlungenDetail />} />

          <Route path='/wohnen-in-der-bgz' element={<WohnenBgz />} />

          <Route path='/anmeldung-wohnen/:title' element={<AnmeldungWohnen />} />

          
          <Route path='/mieterservice' element={<WohnenFormulare />} />
          <Route path='/tipps-und-tricks' element={<WohnenTipps />} />
          <Route path='/hauswartung-notfall' element={<WohnenHauswartung />} />
          <Route path='/freie-mietobjekte' element={<FreieMietobjekte />} />

          <Route path='/freie-mietobjekte/:title' element={<FreieMietobjekteDetail />} />

          <Route path='/fragen-antworten' element={<FragenAntworten />} />

          {/* <Route path='/bauprojekte' element={<Bauprojekte />} /> */}
          <Route path='/neubauprojekte' element={<NeubauProjekte />} />
          <Route path='/neubauprojekte/:title' element={<NeubauProjekteDetail />} />
          
          <Route path='/pionierprojekte' element={<PionierProjekte />} />
          <Route path='/pionierprojekte/:title' element={<PionierProjekteDetail />} />

          <Route path='/sanierungen' element={<Sanierungen />} />
          <Route path='/sanierungen/:title' element={<SanierungenDetail />} />
          <Route path='/wir-suchen-bauland-liegenschaften' element={<GrundstuckVerkaufen />} />


          {/* <Route path='/nachhaltigkeit-innovation' element={<Navigate to="/nachhaltigkeit" replace />} /> */}
          <Route path='/nachhaltigkeit' element={<VorherNachher />} />
          <Route path='/so-leben-wir-nachhaltigkeit' element={<WirNachhaltigkeit />} />
          <Route path='/nachhaltig-bauen' element={<OekologischBauen />} />
          <Route path='/innovationen' element={<Innovationen />} />
          {/* <Route path='/nachhaltigkeit-in-zahlen' element={<NachhaltigkeitZahlen />} /> */}

          {/* <Route path='/genossenschaft' element={<GenossenSchaft />} /> */}
          {/* <Route path='/genossenschaft' element={<Navigate to="/portraet" replace />} /> */}
          <Route path='/portraet' element={<Portrait />} />
          <Route path='/team' element={<Team />} />
          <Route path='/genossenschafter' element={<Genossenschafter />} />
          <Route path='/geschichte' element={<Geschichte />} />
          <Route path='/soziales-engagement' element={<SozialesEngagement />} />
          <Route path='/dokumente-reglemente' element={<DokumenteReglemente />} />
          <Route path='/arbeiten-für-die-bgz' element={<Jobs />} />
          <Route path='/vision-mission-leitbild' element={<VisionMissionLeitbild />} />

          <Route path='/aktuelles' element={<Aktuelles />} />
          <Route path='/aktuelles/:title' element={<AktuellesDetail />} />
          <Route path='/datenschutz' element={<Datenschutz />} />
          <Route path='/impressum' element={<Impressum />} />
          <Route path='/medien' element={<Medien />} />

          <Route path='/vielen-dank' element={<VielenDank />} />
          <Route path='*' element={<Navigate to="/" replace />} />
          <Route path='/suchresultate' element={<SearchResult />} />

          
          <Route path='/anmeldung-mietinteresse' element={<AnmeldungWarteliste />} />
          <Route path='/parkplatz' element={<Parkplatz />} />
          <Route path='/freier-parkplatz' element={<Navigate to="/parkplatz" replace />} />
          <Route path='/interner-wohnungswechsel' element={<InternerWohnungswechsel />} />
          <Route path='/reparaturmeldung' element={<Reparaturmeldung />} />
          <Route path='/schluessel-bestellen' element={<SchlusselBestellen />} />


          {/* <Route path='/strapi-preview' element={<StrapiStructure />} /> */}
        </Routes>
        <Footer />
      </HelmetProvider>
    </BrowserRouter>
  );
}

export default App;